module.exports = __webpack_public_path__ + "static/img/ct-board.7b69856.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ct-board.svg
// module id = RufM
// module chunks = 18